var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-column",class:{ centered: _vm.centered }},[(_vm.t)?[_vm._v(_vm._s(_vm.$t(_vm.t)))]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }